import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  createMuiTheme, MuiThemeProvider, Divider,
} from '@material-ui/core';
import CountUp from 'react-countup';

import { AnimatedProgress } from '../../../../components';

const styles = {
  row: {
    display: 'flex',
    paddingLeft: '10px',
  },
  value: {
    flexGrow: 1,
    textAlign: 'right',
  },
  progress: {
    marginLeft: '10px',
    background: '#ffffff',
  },
  divider: {
    margin: '5px 0 10px',
  },
};

const RenderRow = ({
  colors, name, value, total, index, unit,
}) => {
  const progress = value / total * 100;

  const theme = useMemo(() => createMuiTheme({
    palette: {
      primary: {
        main: colors[index % colors.length],
      },
    },
  }), [colors, index]);


  return (
    <div key={name}>
      <div style={styles.row}>
        <span>{name}</span>
        <CountUp
          end={value}
          suffix={unit}
          decimals={2}
          decimal=","
          style={styles.value}
        />
      </div>
      <MuiThemeProvider theme={theme}>
        <AnimatedProgress
          variant="determinate"
          value={progress}
          color="primary"
          style={styles.progress}
          classes={{ colorPrimary: 'myColorPrimary', barColorPrimary: 'myBarColorPrimary' }}
        />
      </MuiThemeProvider>

      <Divider style={styles.divider} />
    </div>
  );
};

RenderRow.propTypes = {
  colors: PropTypes.array.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  unit: PropTypes.string,
};

RenderRow.defaultProps = {
  unit: '',
};

export default RenderRow;
